import React, { useState, useEffect, useRef } from 'react';
import { Dialog, DialogTitle, DialogContent, Grid, Typography, Checkbox, FormControlLabel} from '@material-ui/core';
import { useDispatch, useSelector} from 'react-redux'
import { makeStyles } from '@material-ui/core/styles';
import { Button, TextField } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Alert from '@material-ui/lab/Alert';
import { Table, TableHead, TableBody, TableCell, TableContainer, TableRow, CircularProgress } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { getWarehouseInfo, getParcelReturnReference, addParcelReturn } from '../../actions/parcelReturnActions';
import { openParcelReturnModal, handleParcelReturnModal, showAlertSnackbar } from '../../reducers/uiSlice';
import {Tooltip } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import update from 'immutability-helper';
import { Skeleton } from '@material-ui/lab';
import { useAlert } from '../../utilities/hooks';
import { alertType } from '../Common/UniAlert/context';
import { CheckCircleOutline, ErrorOutline } from '@material-ui/icons';
import * as Color from '@material-ui/core/colors';
import moment from 'moment';
import { getBranchById, getUserPreference } from '../../utilities/common';


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex', 
        flexDirection: 'column', 
        height: '80vh', 
        paddingTop: theme.spacing(2), 
        paddingBottom: theme.spacing(2)
    },
    loadingStyle: {
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    message:{
        width: '100%'
    }
}));

export default function ParcelReturn(props) {

    const classes = useStyles();
    const {t} = useTranslation('parcelReturn');
    const dispatch = useDispatch();
    const openModal = useSelector(openParcelReturnModal);
    const alertDialog = useAlert();
    const DEFAULT_WAREHOUSE = 1;
    const userPref = getUserPreference();

    // const warehouseList = useSelector(state => state.parcelReturn.warehouseList);
    const warehouseList = useSelector(state => state.common.branches) || [];
    const parcelBatchNo = useSelector(state => state.parcelReturn.parcelBatchNo);
    // const parcelTotal = useSelector(state => state.parcelReturn.parcelTotal);
    const parcelScanStartNo = useSelector(state => state.parcelReturn.parcelScanStartNo) || 0;

    const [parcelRtnNo, setParcelRtnNo] = useState();
    const [fedRtnNo, setFedRtnNo] = useState('');
    const [warehouse, setWarehouse] = useState();
    const [scanList, setScanList] = useState([]);
    const [scanServerResult, setScanServerResult] = useState({});
    const [scanServerError, setScanServerError] = useState(false);
    const [fetchTime, setFetchTime] = useState(moment());
    const [checked, setChecked] = useState(true);
    const [loading, setLoading] = useState(true);

    const lastInputRef = useRef("");
    const tnoTextFieldRef = useRef();
    const scanStatusCount = getScannedStatusCount();


    const handleCheckBoxChange = (event) => {
        setChecked(event.target.checked);
    };

    /**
     * init: 
     * 1. get the warehouse info  
     * 2. get the specific warehouse that deal with the return process 
     *    .get from the local storage if it's exist, could be chaged by the user
     *    .if not exist user should choose the warehouse manually
     */
    useEffect(() => {
        if (openModal) {
            getWarehouse();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openModal]);


    /**
     * get the parcel return reference such as batchNo, parcel total number and scan start no according to the waregouse
     */
    useEffect(() => { (async () => {
        setLoading(true);
        let parcelReturnReference = Promise.resolve([]);

        if (openModal && warehouse !== undefined && warehouse !== null && !isNaN(parseInt(warehouse))) {
            parcelReturnReference = dispatch(getParcelReturnReference(warehouse));
        } else if (warehouseList !== null && warehouseList.length > 0) {
            setWarehouse(warehouseList[0].id);
        }

        try {
            await Promise.all([parcelReturnReference]);
            setLoading(false);
            if (tnoTextFieldRef.current != null) 
                tnoTextFieldRef.current.focus()
            setFetchTime(moment());
        } catch (error) {
            console.error(error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }) ()}, [warehouse]);    

    useEffect(() => {
        if (openModal && !_.isEmpty(scanServerResult)) {
            let data = scanServerResult.data;
            let newList = scanList;
            //No network error
            if (!scanServerError) {
                _.forEach(data, (item) => {
                    if (item.succ === 1){
                        newList = getNewList(item.position, item.tno, item.succ, "SUCCESS", newList)
                    } else {
                        //Not successful, update with fail message
                        newList = getNewList("-", item.tno, item.succ, `FAILED: ${item.message}`, newList)
                    }
                })
            } else {
                newList = getNewList("-", lastInputRef.current, 0, `FAILED: Network Error`, newList)
            }
            setScanList(newList)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scanServerResult])

    return (
        <Dialog 
            onClose={handleClose} 
            open={openModal}
            fullWidth={true}
            maxWidth='lg'
            scroll='body'
        >        
            <DialogTitle>
                {t('title_parcel_return')}
                <Tooltip title={t('common:cancel')} aria-label="cancel" style={{float: "right"}}>
                    <CloseIcon onClick={handleClose}></CloseIcon>
                </Tooltip>
            </DialogTitle>
            <DialogContent dividers>
                <div className={classes.root}>
                    <div style={{paddingBottom: 16}}>
                        <Grid container spacing={2}>
                            <Grid item xs={3} md={3} lg={3}>
                                <TextField
                                    id="parcelRtnNo"
                                    autoFocus
                                    label={t('parcelRtnNo')}
                                    InputLabelProps={{ shrink: true }}
                                    inputRef={tnoTextFieldRef}
                                    type="string"
                                    variant="outlined"
                                    disabled={!parcelBatchNo || loading}
                                    value={parcelRtnNo}
                                    onChange={(e)=>setParcelRtnNo(e.target.value)}
                                    onKeyUp={(e) => handleKeyUp(e)}
                                    fullWidth
                                />
                            </Grid>
                            {
                                checked &&
                                <Grid item xs={3} md={3} lg={3}>
                                    <TextField
                                        id="parcel_return_fedex_tno_textfield"
                                        autoFocus
                                        label={t('fedex_tno')}
                                        InputLabelProps={{ shrink: true }}
                                        inputRef={tnoTextFieldRef}
                                        type="string"
                                        variant="outlined"
                                        disabled={!parcelBatchNo || loading}
                                        value={fedRtnNo}
                                        onChange={(e)=>setFedRtnNo(e.target.value)}
                                        onKeyUp={(e) => handleKeyUp(e)}
                                        fullWidth
                                    />
                                </Grid>
                            }
                            <Grid item xs={3} md={3} lg={3}>
                                <TextField
                                    id="warehouse"
                                    select
                                    label={t('warehouse')}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    value={warehouse}
                                    onChange={(e) => { handleWarehouseChange(e); } }
                                    SelectProps={{
                                        native: true,
                                    }}
                                    fullWidth
                                >
                                    {warehouseList.map((item) => (
                                        <option key={item.name} value={item.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={3} md={2} lg={2}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            id="parcel_return_fedex_tno_checkbox"
                                            label='fedex'
                                            checked={checked}
                                            onChange={handleCheckBoxChange}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />
                                    }
                                    label={t('fedex')}
                                />
                            </Grid>
                            <Grid item xs={3} md={3} lg={3}>
                                <Alert
                                    severity={getAlertColorByStatus()}
                                    classes={{message: classes.message}}
                                >
                                    <div style={{display: 'flex', flexDirection: 'row'}}>
                                        <div style={{width: '100%'}}>
                                            <div>
                                                {t('label_scan_total')}: {scanStatusCount.total}
                                            </div>
                                            <div>
                                                {t('label_scan_success')}: {scanStatusCount.success}
                                            </div>
                                            <div>
                                                {t('label_scan_fail')}: {scanStatusCount.fail}
                                            </div>
                                        </div>
                                        <div style={{width: '100%', alignSelf: 'center'}}>
                                            <Button
                                            variant="contained"
                                            color="secondary"
                                            disabled={scanStatusCount.fail <= 0 || loading}
                                            onClick={handleReScan}
                                            fullWidth
                                            >
                                                {loading ? <CircularProgress size={25} />: t('button_resubmit')}
                                            </Button>
                                        </div>
                                    </div>
                                </Alert>
                            </Grid>
                        </Grid>
                    </div>
                    <Divider/>
                    <div style={{paddingTop: 16}}>
                        <Typography variant='h4' align='center'>
                            {loading ? 
                                <Skeleton 
                                    width={400} 
                                    animation="wave" 
                                    style={{margin: 'auto'}}
                                />
                                : 
                                `${t('label_current_storage_number')} ${getScanListLastId()}`}
                        </Typography>
                        <Typography align='center'>
                            {loading ? 
                                <Skeleton 
                                    width={300} 
                                    animation="wave" 
                                    style={{margin: 'auto'}}
                                />
                                : 
                                `${t('lable_parcelBatchNo')}: ${parcelBatchNo || "Not Loaded"} | 
                                ${t('label_fetched_at')}: ${fetchTime.format("YYYY-MM-DD HH:mm")}`}
                        </Typography>
                    </div>
                    <div style={{paddingTop: 16, overflowY: "auto"}}>
                        <div style={{display: 'flex', height: '100%'}}>
                            <div style={{flexGrow: 1}}>
                                <TableContainer component={Paper} style={{height: '100%'}}>
                                    <Table stickyHeader className={classes.table}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center" style={{width: '20%'}}>{t('storage_info')}</TableCell>
                                                <TableCell align="center" style={{width: '30%'}}>{t('tracking_number')}</TableCell>
                                                <TableCell align="center" style={{width: '50%'}}>{t('status')}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(scanList !== null && scanList.length > 0) ?
                                                _.orderBy(scanList, ['id'], ['asc']).reverse().map((row, index) => (
                                                    <TableRow key={`parcel-return-table-${index}`}>
                                                        <TableCell align="center">{row.id}</TableCell>
                                                        <TableCell align="center">{row.parcelRtnNo}</TableCell>
                                                        <StatusTableCell status={row.status} message={row.message}/>
                                                    </TableRow>
                                                ))
                                                :
                                                null
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );

    /**
     * close the dialog
     */
    function handleClose() {
        setLoading(true);
        dispatch(handleParcelReturnModal(false));
    }

    /**
     * resubmit the failed ones
     */
    function handleReScan() {
        let newList = scanList;
        let list = newList.filter((item)=> item.status === 0);
        let tnoList = _.map(list, 'parcelRtnNo')

        _.forEach(list, (item) => {
            newList = getNewList("-", item.parcelRtnNo, -1, "Loading", newList);
        })
        setScanList(newList);

        postReturnedParcelToServer({
            warehouse: warehouse, 
            batch_no: parcelBatchNo, 
            tnos: tnoList.toString(), 
            storage_info: 0,
            operator: userPref.username,
            add_on: 0,
            local_import: 0,
            is_scanned: 1,
            is_return_scanned: 1,
            version: 0,
            scan_location: getBranchById(userPref.userCity).name
        })
    }

    /**
     * post to the backend when the "Enter" key was pressed
     * @param {*} e 
     */
    function handleKeyUp(e) {
        let parcelRtnNo = e.target.value.trim();
        //keycode 13 is enter  
        if(e.keyCode === 13 && parcelRtnNo.length > 0) {
            //check whether parcelBatchNo info is loaded
            if (!parcelBatchNo) return;
            let nextId = getScanListLastId() + 1

            // get the value and reset the input field
            lastInputRef.current = parcelRtnNo;
            e.target.value = "";
            let scanItemStatus = getScanItemStatus(parcelRtnNo);

            //Stop this function if the item is already processed
            if(scanItemStatus != null && scanItemStatus === 1) {
                dispatch(showAlertSnackbar({title: t('title_parcel_return'), message: t('dialog:already_processed_message'), type: 'warning'}));
                return
            }
            let newList = getNewList(nextId, parcelRtnNo, -1, "Loading", scanList);
            setScanList(newList);
            
            //assemble the params which will post to the backend
            let params = {};
            if (checked) {
                params['fedex_tno'] = fedRtnNo;
            }

            params['scan_location'] = getBranchById(userPref.userCity).name;
            params['warehouse'] = warehouse;
            params['batch_no'] = parcelBatchNo;
            params['tnos'] = parcelRtnNo;
            //params['storage_info'] = parcelScanStartNo + scanList.length + '';
            params['storage_info'] = nextId;
            params['operator'] = userPref.username;

            
            //API needed , don't know the meaning....
            params['add_on'] = 0;
            params['local_import'] = 0;
            params['is_scanned'] = 1;
            params['is_return_scanned'] = 1;
            params['version'] = 0;


            //post
            postReturnedParcelToServer(params)
        }
    }

    async function postReturnedParcelToServer(params) {
        setScanServerResult({})
        try {
            let response = await dispatch(addParcelReturn(params));
            setScanServerResult(response.data)
        }catch(error){
            setScanServerError(true)
        }
    }

    async function getWarehouse() {
        setLoading(true);
        let warehouseInfo = dispatch(getWarehouseInfo());
        try {
            await Promise.all([warehouseInfo]);

            // 读取 localStorage 中 Json 格式数据
            var value = parseInt(localStorage.getItem("warehouse"));    // 取回 value 变量
            if (!isNaN(value)) {
                setWarehouse(value);
            } else if (warehouseList !== null && warehouseList.length > 0) {
                setWarehouse(warehouseList[0].id);
            } else {    //not necessary though...
                setWarehouse(DEFAULT_WAREHOUSE);
            }
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    }

    /**
     * Get the last list ID
     */
    function getScanListLastId() {
        let lastId = _.maxBy(scanList, (o) => {
            return o.id
        })
        return lastId ? isNaN(lastId.id) ? parcelScanStartNo: lastId.id : parcelScanStartNo
    }

    /**
     * Update a new item to scan list
     * @param {String} tno The tracking number
     */
    function getScanItemStatus(tno) {
        let itemIndex = _.findIndex(scanList, {'parcelRtnNo': tno})
        return itemIndex !== -1 ? scanList[itemIndex].status : null
    }

    /**
     * Update a new item to scan list
     * @param {String} id The position of the parcel
     * @param {String} tno Tracking number
     * @param {Number} status -1 = pending, 0 = fail, 1 = success
     * @param {String} message Text message to display to users
     * @param {Array} scanList 
     */
    function getNewList(id, tno, status, message, scanList) {
        let itemIndex = _.findIndex(scanList, {'parcelRtnNo': tno})
        let newList = []

        if (itemIndex !== -1) {
            //Update
            newList = update(scanList, {[itemIndex]: {$set: {id, parcelRtnNo: tno, status, message}}})
        } else {
            //Insert
            newList = update(scanList, {$push: [{id, parcelRtnNo: tno, status, message}]})
        }
        return newList
    }

    /**
     * Get the status counts
     */
    function getScannedStatusCount() {
        let result = {
            total: scanList.length,
            success: 0,
            fail: 0
        }
        _.forEach(scanList, (item) => {
            if(item.status === 1){
                result.success += 1
            } else if(item.status === 0) {
                result.fail += 1
            }
        })
        return result
    }

    function getAlertColorByStatus () {
        if(scanStatusCount.fail > 0 && scanStatusCount.success > 0){
            return "warning"
        } else if(scanStatusCount.success > scanStatusCount.fail){
            return "success"
        } else if(scanStatusCount.fail > scanStatusCount.success){
            return "error"
        } else if(scanStatusCount.success === 0 && scanStatusCount.fail ===0){
            return "success"
        } else {
            return "error"
        }
    }

    /**
     * save the warehouse value to localstorage when it changes
     * @param {*} e 
     */
    function handleWarehouseChange(e) {
        let newWarehouse = e.target.value;
        if(scanList.length > 0){
            alertDialog.addAlertDialog(
                t('title_parcel_return'), 
                t('dialog:change_warehouse_parcel_return_message'), 
                alertType.INFO,
                t('common:cancel'));
            alertDialog.addActionButton(
                t('common:confirm'), 
                ()=>{
                    changeWarehouse(newWarehouse);
                    setScanList([]);
                    alertDialog.hideAlert();
                },
                "primary");
            alertDialog.showAlert();
        } else {
            changeWarehouse(newWarehouse)
        }

        function changeWarehouse(value) {
            console.log(value)
            let warehouse = parseInt(value);
            setWarehouse(warehouse);
            // 存储 localStorage 
            localStorage.setItem("warehouse", warehouse);  
        }
    }

}

const StatusTableCell = (props) => {
    let icon;
    switch(props.status){
        case 0:
            icon = <ErrorOutline color="error" fontSize='small' style={{verticalAlign: 'middle'}}/>
            break;
        case 1:
            icon = <CheckCircleOutline fontSize='small' style={{verticalAlign: 'middle', color: Color.green[600]}}/>
            break;
        case -1:
            icon = <ErrorOutline color="secondary" fontSize='small' style={{verticalAlign: 'middle'}}/>
            break;
        default:
            break;
    }

    return <TableCell align="center">{icon} {props.message}</TableCell>
}


